import {
  SHEET_HEIGHT_FRACTIONS,
  snapSheetHeight,
} from '@/components/pos-v2/ui/pos-ui-sheet.utils';

/**
 * Layout tiers of the «Asistente» panel (plan §9.2): a right sidebar that
 * pushes the page on wide screens, an overlay drawer on tablets and a bottom
 * sheet on phones. Widths are the stable window width (never the
 * keyboard-shrunk one).
 */
export type TAssistantTier = 'docked' | 'overlay' | 'sheet';

/** The two resting heights of the phone sheet (92 % / 40 % of the stable height). */
export type TAssistantSheetHeight = 'lg' | 'sm';

/** From this width the panel is docked and pushes the page. */
export const DOCKED_MIN = 1024;
/** Up to this width the panel is a bottom sheet. */
export const SHEET_MAX = 599;
/** Width of the docked panel (px), registered in Vuetify's layout. */
export const DOCKED_WIDTH = 400;
/** Width of the overlay drawer (px). */
export const OVERLAY_WIDTH = 420;
/** Room the overlay always leaves on the left, so the page stays tappable (px). */
export const OVERLAY_EDGE = 56;

export function assistantTier(width: number): TAssistantTier {
  if (width >= DOCKED_MIN) return 'docked';
  if (width > SHEET_MAX) return 'overlay';
  return 'sheet';
}

/** Right inset the page makes room for: only a shown, docked panel pushes it. */
export function assistantInsetRight(input: {
  shown: boolean;
  tier: TAssistantTier;
}): number {
  return input.shown && input.tier === 'docked' ? DOCKED_WIDTH : 0;
}

/**
 * Where a released sheet drag rests: `null` (close) below the shared close
 * fraction, otherwise the nearer of the two resting heights.
 */
export function snapAssistantSheet(
  px: number,
  stableHeight: number
): TAssistantSheetHeight | null {
  if (snapSheetHeight(px, stableHeight) === null) return null;
  const fraction = px / stableHeight;
  if (!Number.isFinite(fraction)) return 'lg';
  const { sm, lg } = SHEET_HEIGHT_FRACTIONS;
  return Math.abs(lg - fraction) <= Math.abs(sm - fraction) ? 'lg' : 'sm';
}
